__webpack_require__.p = "https://bbmjs.jiyuantown.com/build1/";